const NAMESPACE = 'PLAYER'

export const SET_PLAYQUEUE = `${NAMESPACE}/SET_PLAYQUEUE`
export const SET_PLAYQUEUE_NEXT = `${NAMESPACE}/SET_PLAYQUEUE_NEXT`
export const SET_PLAYQUEUE_END = `${NAMESPACE}/SET_PLAYQUEUE_END`
export const SET_MOVE_IN_PLAYQUEUE = `${NAMESPACE}/SET_MOVE_IN_PLAYQUEUE`

export const SET_LOADED = `${NAMESPACE}/SET_LOADED`
export const SET_PLAYING = `${NAMESPACE}/SET_PLAYING`
export const SET_SEEK = `${NAMESPACE}/SET_SEEK`
export const SET_BUFFERING = `${NAMESPACE}/SET_BUFFERING`
export const SET_BUFFERS = `${NAMESPACE}/SET_BUFFERS`
export const SET_CURRENT_GETFILEURL = `${NAMESPACE}/SET_CURRENT_GETFILEURL`


export const SET_FROM_STORAGE = `${NAMESPACE}/SET_FROM_STORAGE`

export const CLEAR_PLAYQUEUE = `${NAMESPACE}/CLEAR_PLAYQUEUE`



// WEBPACK FOOTER //
// ./src/components/miniPlayer/AudioPlayer/actionsNames.js